export default __webpack_public_path__ + "static/media/support_graphic.479415ff.png";